export type LogoSurface = 'light' | 'dark';
export const LOGO_SURFACES = {light:'#ffffff',dark:'#060d2b'};

function linear(value:number):number {
  const c=value/255;return c<=.04045?c/12.92:Math.pow((c+.055)/1.055,2.4);
}
function luminance(r:number,g:number,b:number):number {return .2126*linear(r)+.7152*linear(g)+.0722*linear(b);}
function contrast(a:number,b:number):number {return (Math.max(a,b)+.05)/(Math.min(a,b)+.05);}

export function preferredLogoSurface(pixels:Uint8ClampedArray,width:number,height:number):LogoSurface {
  if(width<1||height<1||pixels.length!==width*height*4)return 'light';
  let whiteBorder=0,border=0;
  for(let y=0;y<height;y++)for(let x=0;x<width;x++) {
    if(x!==0&&y!==0&&x!==width-1&&y!==height-1)continue;
    const i=(y*width+x)*4;border++;
    if(pixels[i]>245&&pixels[i+1]>245&&pixels[i+2]>245&&pixels[i+3]>240)whiteBorder++;
  }
  // An opaque white backdrop is part of the image, not transparent padding.
  // Keep its frame light rather than treating that backdrop as white artwork.
  if(border&&whiteBorder/border>.75)return 'light';
  const dark=[6,13,43],darkLuminance=luminance(6,13,43);
  let lightScore=0,darkScore=0,weight=0;
  for(let i=0;i<pixels.length;i+=4) {
    const alpha=pixels[i+3]/255;if(alpha<.1)continue;
    const r=pixels[i],g=pixels[i+1],b=pixels[i+2];weight+=alpha;
    lightScore+=alpha*contrast(luminance(r*alpha+255*(1-alpha),g*alpha+255*(1-alpha),b*alpha+255*(1-alpha)),1);
    darkScore+=alpha*contrast(luminance(r*alpha+dark[0]*(1-alpha),g*alpha+dark[1]*(1-alpha),b*alpha+dark[2]*(1-alpha)),darkLuminance);
  }
  return weight&&darkScore>lightScore?'dark':'light';
}
